import { render, staticRenderFns } from "./kouluttaja.vue?vue&type=template&id=a939643e&scoped=true&"
import script from "./kouluttaja.vue?vue&type=script&lang=ts&"
export * from "./kouluttaja.vue?vue&type=script&lang=ts&"
import style0 from "./kouluttaja.vue?vue&type=style&index=0&id=a939643e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a939643e",
  null
  
)

export default component.exports